import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Select, Table } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { getMyFarmAnimalList, doMyFarmAnimalDelete, doMyFarmAnimalConditionUpdate } from "../../../../redux/farmanimal/farmAnimalState";
import { getMyFarmParcelList } from "../../../../redux/farmparcel/farmParcelState";
import { getAnimalConditions } from "../../../../redux/dynamiclist/dynamicListState";
import { handleTableChange } from "../../../../utils/index";
import CrudButtons from "components/button/crudbuttons";
import { checkIfUserInLocation } from "../../../../utils/geoFenceChecker";
import { displayFarmNameLocation } from "../../../../utils/index";

const MyRegisteredAnimalsTable = ({ recordList, 
	pagination, doSearch, 
	doDelete, filters, 
	doAnimalCondition, 
	conditionOptions, 
	doAnimalConditionUpdate,
	getMyFarmLocations,
	myFarmLocations 
}) => {

	const [isAllowedAdd, setIsAllowedAdd] = useState(true);

  	const columns = [
		{
	        title: `Category`,
	        dataIndex: 'category',
	        key: 'category',
	        width: '10%',
	        sorter: true,
	        render:(category) => <span>{category?.name}</span>
	    },
		{
	        title: `Type`,
	        dataIndex: 'type',
	        key: 'type',
	        width: '10%',
	        sorter: true,
	        render:(type) => <span>{type?.name}</span>
	    },	    
		{
	        title: <div className="text-right">Headcount</div>,
	        dataIndex: 'headcount',
	        key: 'headcount',
	        width: '6%',
	        render:(headcount) => <div className="text-right">{headcount}</div>
	    },
		{
	        title: `Condition`,
	        dataIndex: 'condition_id',
	        key: 'condition_id',
	        width: '15%',
	        render:(condition_id, record) => <div className="w-full">
				{ checkIfUserInLocation(record?.farm?.address?.province) ? 
					<Select className="w-full" 
						id={`condition-${record.id}`}
						value={parseInt(condition_id)}
						options={conditionOptions}
						onChange={(value) => {
							doAnimalConditionUpdate({'id':record.id, 'condition':value});
						}}
					/>
					:
					<>{record?.condition?.name}</>
					}
				</div>
	    },
		{
	        title: `Purpose`,
	        dataIndex: 'purpose',
	        key: 'purpose',
	        width: '12%',
	        render:(purpose) => <span>{purpose?.name}</span>
	    },	
		{
	        title: `Breed`,
	        dataIndex: 'breed',
	        key: 'breed',
	        width: '12%',
	        render:(breed) => <span>{breed}</span>
	    },    
		{
	        title: `Farm`,
	        dataIndex: 'farm',
	        key: 'farm',
	        width: '22%',
	        render:(farm) => displayFarmNameLocation(farm)
	    },
	    {
	        title: isAllowedAdd ? (<Button extra="btn-small">
			      		<a href={`/panel/my-registered-animals/add`}>
					        <PlusOutlined />{' '}Add
					  	</a>
			    	</Button>) : (''),
	        dataIndex: 'id',
	        key: 'id',
	        width: '13%',
	        render:(id, record) => 
				<CrudOption baseRoute="/panel/my-registered-animals" 
					recordId={id} 
					deleteHandler={doDelete}
					allowEdit={checkIfUserInLocation(record?.farm?.address?.province)}
					allowDelete={checkIfUserInLocation(record?.farm?.address?.province)}
			/>
	    },
    ];
	
	useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

	useEffect(() => {
		if (!conditionOptions?.length) {
		  doAnimalCondition(null);
		}
	  }, [doAnimalCondition]);

	useEffect(() => {
		if (!myFarmLocations?.length) {
		  getMyFarmLocations(null);
		}
	  }, [getMyFarmLocations]);

	// useEffect(() => {
	// 	console.log(myFarmLocations);
	// 	myFarmLocations?.forEach((myFarmLocation) => {
	// 		if(checkIfUserInLocation(myFarmLocation.address?.province)){
	// 			setIsAllowedAdd(true);
	// 			console.log(true);
	// 			return;
	// 		}else{
	// 			setIsAllowedAdd(false);
	// 			console.log(false);
	// 		}
	// 	});
	// }, [myFarmLocations]);

  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden mb-3">	      	
	      		<Table
		        	dataSource={recordList}
		        	columns={columns} 
		            rowKey={(record) => record.id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}
		            onChange={handleTableChange(doSearch, filters)}  
	        	/>
	      	</div>
			<CrudButtons baseRoute="/panel/my-registered-animals" 
				mode="view" 
				backUrl="/panel/services"
				cancelLabel="Back"
				withEdit={false}/>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.farmAnimal.recordList?.items,
	pagination: state.farmAnimal.recordList?.pagination,
	filters: state.farmAnimal.recordList?.filters,
  	requesting: state.farmAnimal.recordList?.requesting,
  	error: state.farmAnimal.recordList?.error,	  
	conditionOptions: state.dynamicList.animalConditions?.items,
	myFarmLocations: state.farmParcel.recordList?.items,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getMyFarmAnimalList(filters)),
  doDelete: (id) => dispatch(doMyFarmAnimalDelete(id)),
  doAnimalCondition: (filters) => dispatch(getAnimalConditions(filters)),
  doAnimalConditionUpdate: (filters) => dispatch(doMyFarmAnimalConditionUpdate(filters)),
  getMyFarmLocations: (filters) => dispatch(getMyFarmParcelList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyRegisteredAnimalsTable);